import type { BotApi } from './BotApi';
import { localBotApi } from './localBotApi';
import { mockBotApi } from './mockBotApi';
import { supabaseBotApi } from './supabaseBotApi';
import { runtimeConfig } from '../config/runtimeConfig';

export function createBotApi(): BotApi {
  const mode = runtimeConfig().apiMode;
  if (mode === 'local') return localBotApi;
  if (mode === 'supabase') return supabaseBotApi;
  return mockBotApi;
}
